import React, { Fragment, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { AuthContext } from "../context/authContext";
import alertService from "../services/sweetAlert";


export default function Register() {
  const { register } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [acceptTACs, setAcceptTACs] = useState(false);

  const handleSubmit = async () => {
    console.log(acceptTACs)
    if(!acceptTACs) {
      alertService.info(
        'Error',
        'If you accept terms only then you are allwoed to register!');
      return;
    }
    //e.preventDefault();
    if (password === confirmpassword) {
      const user = await register({ name, email, password });
      //console.log(user)
    } else {
      alertService.info(
        'Error',
        'Passwords must match!');
      return;
    
    }
  };
  return (
    <Fragment>
      <Helmet>
        <title>Register - Geet Suhane | Join India's Music Community</title>
        <meta name="description" content="Create your free account on Geet Suhane - Join India's premier music community. Access live voice rooms, AI lyrics generator, games and connect with music lovers." />
        <meta name="keywords" content="register, sign up, create account, Geet Suhane, music community, Indian music" />
        <meta property="og:title" content="Register on Geet Suhane" />
        <meta property="og:description" content="Create your free account. Join India's premier music community!" />
        <link rel="canonical" href="https://geetsuhane.com/register" />
      </Helmet>
      <div className="main-wrap">
        <div className="nav-header bg-transparent shadow-none border-0">
          <div className="nav-top w-100">
            <Link
              to="/login"
              className="header-btn d-none d-lg-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl"
            >
              Login
            </Link>
            <Link
              to="/register"
              className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl"
            >
              Register
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-7 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
            <div className="card shadow-none border-0 ms-auto me-auto login-card">
              <div className="card-body rounded-0 text-left">
                <h2 className="fw-700 display1-size display2-md-size mb-4">
                  Create <br />
                  your account
                </h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group icon-input mb-3">
                    <i className="font-sm ti-user text-grey-500 pe-0"></i>
                    <input
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      type="text"
                      className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                      placeholder="Your Name"
                    />
                  </div>
                  <div className="form-group icon-input mb-3">
                    <i className="font-sm ti-email text-grey-500 pe-0"></i>
                    <input
                    value={email}
                    onChange={(e)=>{
                        setEmail(e.target.value)
                    }}
                      type="email"
                      className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                      placeholder="Your Email Address"
                    />
                  </div>
                  <div className="form-group icon-input mb-3">
                    <input
                    value={password}
                    onChange={(e)=>{
                        setPassword(e.target.value)
                    }}
                      type="Password"
                      className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                      placeholder="Password"
                    />
                    <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                  </div>
                  <div className="form-group icon-input mb-1">
                    <input
                    value={confirmpassword}
                    onChange={(e)=>{
                        setConfirmpassword(e.target.value)
                    }}
                      type="Password"
                      className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                      placeholder="Confirm Password"
                    />
                    <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                  </div>
                  <div className="form-check text-left mb-3">
                    <input
                    checked={acceptTACs}
                    onChange={(e)=>{
                        setAcceptTACs(e.target.checked)
                    }}
                      type="checkbox"
                      className="form-check-input mt-2"
                      id="exampleCheck2"
                    />
                    <label className="form-check-label font-xsss text-grey-500">
                      <a href="/terms">
                      Accept Term and Conditions</a>
                    </label>
                  </div>

                
                    <div className="form-group mb-1">
                      <div
                         onClick={handleSubmit}
                        className="form-control text-center style2-input text-white fw-600 bg-dark border-0 p-0 cursor-pointer"
                      >
                        Register
                      </div>
                    </div>
                    <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                      Already have account{" "}
                      <Link to="/login" className="fw-700 ms-1">
                        Login
                      </Link>
                    </h6>
                    <div className="font-xsssss">Please contact support@geetsuhane.com or whatsup +1 332 287 8300 if you have any queries.</div>
                </form>
              </div>
            </div>
           
          </div>
        </div>
        
      </div>
    </Fragment>
  );
}
